import {parsePhoneNumber, parsePhoneNumberFromString} from 'libphonenumber-js'

export default (phone, countryIsoCode) => {
  try {
    countryIsoCode = countryIsoCode || 'AR'
    let checkedPhone = parsePhoneNumberFromString(phone, countryIsoCode)
    if (checkedPhone.isValid() === false) {
      phone = phone[0] === '0' ? '+' + phone.slice(1) : phone
      checkedPhone = parsePhoneNumberFromString(phone, countryIsoCode)
    }

    checkedPhone = checkedPhone.format('E.164')
    const phoneNumber = parsePhoneNumber(checkedPhone)
    const retPhone = phoneNumber ? phoneNumber.formatInternational() : phone

    return retPhone
  } catch (e) {
    return phone
  }
}
